import React, { useEffect, useRef, useState } from 'react'
import styles from '../styles/vipLists.module.scss'
import { useTranslation } from 'react-i18next'


interface VipListsProps {
  list: any[]
  onTitle: (v: any,index3: number) => any
  onValue: (v: any, e: any, index: number, index2: number) => any
}

const VipLists: React.FC<VipListsProps> = (props) => {
  const {list,onTitle,onValue} = props
  const { t } = useTranslation('vip')
  const vipList = [
    'VIP0',
    'VIP1',
    'VIP2',
    'VIP3',
    'VIP4',
    'VIP5',
    'VIP6',
    'VIP7',
    'VIP8',
    'VIP9',
    'VIP10'
  ]

  return (
    <div className={styles.vipLists}>
      <div className={styles.lists_title}>
        <div>{t('vipLevel')}</div>
        {list?.map((v,index3)=>
          onTitle(v, index3)
        )}
      </div>

      <div className={styles.lists_content}>
        {vipList.map((e,index1)=>{
          return <div key={index1} className={styles.lists_item}>
            <div>{e}</div>
            {list?.map((x,index2)=>
              onValue(e,x,index1,index2)
            )}
          </div>
        })}
      </div>
    </div>  
  ) 
}

export default VipLists
